module.exports = __webpack_public_path__ + "static/media/sancoIcon_trans.ddc96d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/sancoIcon_trans.png
// module id = 3
// module chunks = 0